export default __webpack_public_path__ + "static/media/vivabonito4.e5268881.jpg";